import { SectionNames } from './homePage.reducer';
import { AppState, HomePageAppState } from '../../initialStateRegistration';

export const getHomePage = (state: AppState) => (state as HomePageAppState).template;

export const getSectionDataByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key];

export const getSectionArticlesByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionDisplayNameByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].displayName;

export const getSectionLinkByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].link;

export const getSectionTextByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].text;
